import { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const infos = [
  {
    icon: "ri-phone-line",
    label: "Téléphone",
    value: "01 75 43 43 46",
    href: "tel:+33175434346",
    sub: "Lun–Jeu : 8h30–17h30 | Ven : 8h30–12h30",
  },
  {
    icon: "ri-mail-line",
    label: "Email",
    value: "contact@ksbtp.fr",
    href: "mailto:contact@ksbtp.fr",
    sub: "Réponse sous 24h",
  },
  {
    icon: "ri-map-pin-line",
    label: "Adresse",
    value: "9 rue de Lamirault",
    href: "https://maps.google.com/?q=9+rue+de+Lamirault+77090+Collegien",
    sub: "77090 Collégien",
  },
  {
    icon: "ri-time-line",
    label: "Horaires",
    value: "Lun–Jeu : 8h30–17h30",
    href: null,
    sub: "Vendredi : 8h30–12h30",
  },
];

const services = [
  "Toiture-terrasse",
  "Parking (enrobés & asphalte)",
  "Dalle carrossable",
  "Terrasse",
  "Étanchéité + isolation thermique",
  "Réfection étanchéité existante",
  "Autre",
];

export default function ContactPage() {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [charCount, setCharCount] = useState(0);


  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    const form = e.currentTarget;
    const formData = new FormData(form);
    const body = new URLSearchParams();
    formData.forEach((value, key) => {
      body.append(key, value.toString());
    });

    try {
      const res = await fetch("https://readdy.ai/api/form/d7ibm6haljjjkv6jgnc0", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });
      if (res.ok) {
        setSubmitted(true);
        form.reset();
        setCharCount(0);
      }
    } catch {
      // silent
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
    <Navbar />
    <main className="pt-20 bg-white">

      {/* Hero */}
      <section className="relative h-[320px] md:h-[420px] flex items-end overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=professional%20waterproofing%20construction%20team%20on%20rooftop%2C%20workers%20in%20safety%20gear%2C%20urban%20Paris%20skyline%20background%2C%20golden%20hour%20warm%20light%2C%20wide%20angle%20view%2C%20professional%20BTP%20etancheite%20photography%2C%20impressive%20scale%2C%20clean%20modern%20building&width=1440&height=700&seq=ksbtp-contact-hero-001&orientation=landscape"
          alt="Contactez KS BTP"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/55 to-black/20"></div>
        <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 pb-10 md:pb-14">
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 text-green-300 text-xs font-semibold mb-4 hover:text-white transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-line"></i>
            Retour à l&apos;accueil
          </Link>
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-[#00a340]/60 bg-[#00a340]/15 mb-4">
            <span className="w-1.5 h-1.5 rounded-full bg-[#4cd97a] inline-block"></span>
            <span className="text-[#a8f0c0] text-xs font-bold uppercase tracking-widest">Devis gratuit sous 48h</span>
          </div>
          <h1
            className="text-3xl md:text-6xl font-extrabold text-white leading-tight mb-3"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            Contactez-<span className="italic text-[#4cd97a]">nous</span>
          </h1>
          <p className="text-gray-200 text-sm md:text-lg max-w-xl leading-relaxed">
            Un projet d&apos;étanchéité ? Nos experts vous répondent sous 48h avec un devis personnalisé et gratuit.
          </p>
        </div>
      </section>

      {/* Infos rapides */}
      <section className="py-10 md:py-14 bg-[#f8fdf9] border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            {infos.map((info) => (
              <div key={info.label} className="bg-white rounded-2xl p-5 md:p-6 border border-gray-100 hover:border-[#a8f0c0] transition-colors group">
                <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-[#e6f7ed] text-[#00a340] mb-4 group-hover:bg-[#00a340] group-hover:text-white transition-colors">
                  <i className={`${info.icon} text-xl`}></i>
                </div>
                <div className="text-xs font-bold uppercase tracking-widest text-gray-400 mb-1">{info.label}</div>
                {info.href ? (
                  <a
                    href={info.href}
                    target={info.href.startsWith("http") ? "_blank" : undefined}
                    rel={info.href.startsWith("http") ? "noopener noreferrer nofollow" : undefined}
                    className="font-bold text-gray-900 text-sm hover:text-[#00a340] transition-colors cursor-pointer block"
                  >
                    {info.value}
                  </a>
                ) : (
                  <span className="font-bold text-gray-900 text-sm block">{info.value}</span>
                )}
                <div className="text-xs text-gray-400 mt-0.5">{info.sub}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Formulaire + carte */}
      <section className="py-14 md:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16 items-start">

            {/* Formulaire */}
            <div>
              <span className="text-xs font-bold uppercase tracking-widest text-[#00a340] mb-2 block">Formulaire de contact</span>
              <h2
                className="text-2xl md:text-4xl font-extrabold text-gray-900 mb-2 leading-tight"
                style={{ fontFamily: "'Montserrat', sans-serif" }}
              >
                Demandez votre{" "}
                <span className="italic text-[#00a340]">devis gratuit</span>
              </h2>
              <p className="text-gray-500 text-sm mb-8">Remplissez le formulaire, nous vous recontactons sous 48h.</p>

              {submitted ? (
                <div className="p-8 rounded-2xl bg-[#e6f7ed] border border-[#a8f0c0] text-center">
                  <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#00a340] text-white mx-auto mb-4">
                    <i className="ri-checkbox-circle-line text-3xl"></i>
                  </div>
                  <h3 className="font-extrabold text-gray-900 text-lg mb-2" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                    Demande envoyée !
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed mb-5">
                    Merci pour votre message. Notre équipe vous recontactera dans les plus brefs délais, sous 48h maximum.
                  </p>
                  <button
                    onClick={() => setSubmitted(false)}
                    className="px-6 py-2.5 rounded-lg bg-[#00a340] text-white font-semibold text-sm hover:bg-[#007a30] transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Envoyer une autre demande
                  </button>
                </div>
              ) : (
                <form data-readdy-form onSubmit={handleSubmit} className="flex flex-col gap-4">
                  <div className="flex flex-col sm:flex-row gap-4">
                    <div className="flex-1">
                      <label className="block text-xs font-semibold text-gray-600 mb-1.5">Prénom *</label>
                      <input
                        type="text"
                        name="prenom"
                        required
                        placeholder="Jean"
                        className="w-full px-4 py-3 rounded-lg border border-gray-200 bg-white text-sm text-gray-800 focus:outline-none focus:border-[#00a340] transition-colors"
                      />
                    </div>
                    <div className="flex-1">
                      <label className="block text-xs font-semibold text-gray-600 mb-1.5">Nom *</label>
                      <input
                        type="text"
                        name="nom"
                        required
                        placeholder="Dupont"
                        className="w-full px-4 py-3 rounded-lg border border-gray-200 bg-white text-sm text-gray-800 focus:outline-none focus:border-[#00a340] transition-colors"
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-xs font-semibold text-gray-600 mb-1.5">Email *</label>
                    <input
                      type="email"
                      name="email"
                      required
                      placeholder="jean.dupont@email.fr"
                      className="w-full px-4 py-3 rounded-lg border border-gray-200 bg-white text-sm text-gray-800 focus:outline-none focus:border-[#00a340] transition-colors"
                    />
                  </div>

                  <div>
                    <label className="block text-xs font-semibold text-gray-600 mb-1.5">Téléphone *</label>
                    <input
                      type="tel"
                      name="telephone"
                      required
                      placeholder="+33 6 XX XX XX XX"
                      className="w-full px-4 py-3 rounded-lg border border-gray-200 bg-white text-sm text-gray-800 focus:outline-none focus:border-[#00a340] transition-colors"
                    />
                  </div>

                  <div>
                    <label className="block text-xs font-semibold text-gray-600 mb-1.5">Société / Organisation</label>
                    <input
                      type="text"
                      name="societe"
                      placeholder="Nom de votre entreprise (optionnel)"
                      className="w-full px-4 py-3 rounded-lg border border-gray-200 bg-white text-sm text-gray-800 focus:outline-none focus:border-[#00a340] transition-colors"
                    />
                  </div>

                  <div>
                    <label className="block text-xs font-semibold text-gray-600 mb-1.5">Type de travaux</label>
                    <select
                      name="type_travaux"
                      className="w-full px-4 py-3 rounded-lg border border-gray-200 bg-white text-sm text-gray-800 focus:outline-none focus:border-[#00a340] transition-colors cursor-pointer"
                    >
                      <option value="">Sélectionnez le type de travaux</option>
                      {services.map((s) => (
                        <option key={s} value={s}>{s}</option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <label className="block text-xs font-semibold text-gray-600 mb-1.5">Localisation du chantier</label>
                    <input
                      type="text"
                      name="localisation"
                      placeholder="Ville, département ou adresse"
                      className="w-full px-4 py-3 rounded-lg border border-gray-200 bg-white text-sm text-gray-800 focus:outline-none focus:border-[#00a340] transition-colors"
                    />
                  </div>

                  <div>
                    <div className="flex items-center justify-between mb-1.5">
                      <label className="block text-xs font-semibold text-gray-600">Description du projet</label>
                      <span className={`text-xs ${charCount > 450 ? "text-red-400" : "text-gray-400"}`}>{charCount}/500</span>
                    </div>
                    <textarea
                      name="message"
                      rows={5}
                      maxLength={500}
                      placeholder="Décrivez votre projet : type d'ouvrage, surface approximative, délais souhaités, contraintes particulières..."
                      onChange={(e) => setCharCount(e.target.value.length)}
                      className="w-full px-4 py-3 rounded-lg border border-gray-200 bg-white text-sm text-gray-800 focus:outline-none focus:border-[#00a340] transition-colors resize-none"
                    ></textarea>
                  </div>

                  <button
                    type="submit"
                    disabled={loading}
                    className="w-full py-3.5 rounded-lg bg-[#00a340] text-white font-bold text-sm whitespace-nowrap hover:bg-[#007a30] transition-colors cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                  >
                    {loading ? (
                      <>
                        <i className="ri-loader-4-line animate-spin"></i>
                        Envoi en cours...
                      </>
                    ) : (
                      <>
                        Envoyer ma demande de devis
                        <i className="ri-arrow-right-line"></i>
                      </>
                    )}
                  </button>

                  <p className="text-xs text-gray-400 text-center">
                    En soumettant ce formulaire, vous acceptez d&apos;être recontacté par KS BTP concernant votre projet.
                  </p>
                </form>
              )}
            </div>

            {/* Infos + carte */}
            <div className="flex flex-col gap-6">
              {/* Carte Google Maps */}
              <div className="rounded-2xl overflow-hidden border border-gray-100" style={{ height: "300px" }}>
                <iframe
                  title="KS BTP - 9 rue de Lamirault, Collégien"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2628.0!2d2.7!3d48.83!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e5f9b0b0b0b0b0%3A0x0!2s9+Rue+de+Lamirault%2C+77090+Coll%C3%A9gien!5e0!3m2!1sfr!2sfr!4v1700000000000!5m2!1sfr!2sfr"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>

              {/* Bloc contact direct */}
              <div className="bg-[#0d2b18] rounded-2xl p-6 md:p-8 text-white">
                <h3 className="font-extrabold text-lg mb-1" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                  Besoin d&apos;une réponse rapide ?
                </h3>
                <p className="text-gray-300 text-sm mb-6 leading-relaxed">
                  Appelez-nous directement ou envoyez-nous un email. Nos équipes sont disponibles du lundi au vendredi.
                </p>
                <div className="flex flex-col gap-4">
                  <a
                    href="tel:+33175434346"
                    className="flex items-center gap-4 p-4 rounded-xl bg-[#00a340]/20 hover:bg-[#00a340]/30 transition-colors cursor-pointer group"
                  >
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#00a340] text-white flex-shrink-0">
                      <i className="ri-phone-fill text-base"></i>
                    </div>
                    <div>
                      <div className="text-xs text-gray-400 mb-0.5">Téléphone</div>
                      <div className="font-bold text-white text-sm group-hover:text-[#4cd97a] transition-colors">01 75 43 43 46</div>
                    </div>
                    <i className="ri-arrow-right-line text-gray-500 ml-auto group-hover:text-[#4cd97a] transition-colors"></i>
                  </a>
                  <a
                    href="mailto:contact@ksbtp.fr"
                    className="flex items-center gap-4 p-4 rounded-xl bg-white/5 hover:bg-white/10 transition-colors cursor-pointer group"
                  >
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 text-white flex-shrink-0">
                      <i className="ri-mail-line text-base"></i>
                    </div>
                    <div>
                      <div className="text-xs text-gray-400 mb-0.5">Email</div>
                      <div className="font-bold text-white text-sm group-hover:text-[#4cd97a] transition-colors">contact@ksbtp.fr</div>
                    </div>
                    <i className="ri-arrow-right-line text-gray-500 ml-auto group-hover:text-[#4cd97a] transition-colors"></i>
                  </a>
                  <a
                    href="https://maps.google.com/?q=9+rue+de+Lamirault+77090+Collegien"
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="flex items-center gap-4 p-4 rounded-xl bg-white/5 hover:bg-white/10 transition-colors cursor-pointer group"
                  >
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 text-white flex-shrink-0">
                      <i className="ri-map-pin-line text-base"></i>
                    </div>
                    <div>
                      <div className="text-xs text-gray-400 mb-0.5">Adresse</div>
                      <div className="font-bold text-white text-sm group-hover:text-[#4cd97a] transition-colors">9 rue de Lamirault, 77090 Collégien</div>
                    </div>
                    <i className="ri-arrow-right-line text-gray-500 ml-auto group-hover:text-[#4cd97a] transition-colors"></i>
                  </a>
                </div>
              </div>

              {/* Zone d'intervention */}
              <div className="rounded-2xl border border-gray-100 bg-[#f8fdf9] p-6">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-[#e6f7ed] text-[#00a340]">
                    <i className="ri-map-2-line text-lg"></i>
                  </div>
                  <h4 className="font-bold text-gray-900 text-sm">Zone d&apos;intervention</h4>
                </div>
                <p className="text-gray-500 text-xs leading-relaxed mb-3">
                  KS BTP intervient principalement en <strong className="text-gray-700">Île-de-France</strong> et dans les départements limitrophes pour tous vos projets d&apos;étanchéité.
                </p>
                <div className="flex flex-wrap gap-2">
                  {["Paris (75)", "Seine-et-Marne (77)", "Yvelines (78)", "Essonne (91)", "Hauts-de-Seine (92)", "Seine-Saint-Denis (93)", "Val-de-Marne (94)", "Val-d'Oise (95)"].map((dep) => (
                    <span key={dep} className="px-2.5 py-1 rounded-full bg-white border border-gray-200 text-gray-600 text-xs font-medium">
                      {dep}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </main>
    <Footer />
    </div>
  );
}
